import React from 'react';
import {Link} from 'react-router';
import {useAuthContext} from '../../context/AuthContext';
import {NavigationRoutes} from '../../NavigationRoutes';

/** Up to two initials from a display name, else the first letter of the email/username. */
export const getInitials = (name?: string | null, fallback?: string | null) => {
    const words = (name ?? '')
        .replace(/\(.*?\)/g, ' ')
        .split(/[\s._-]+/)
        .filter(w => /^\p{L}/u.test(w));
    if (words.length >= 2) {
        return (words[0][0] + words[words.length - 1][0]).toUpperCase();
    }
    if (words.length === 1) {
        return words[0][0].toUpperCase();
    }
    const first = (fallback ?? '').trim()[0];
    return first ? first.toUpperCase() : '?';
};

interface UserAvatarProps {
    className?: string;
}

/** The signed-in user's initials in a circle, linking to their Profile page. */
const UserAvatar: React.FC<UserAvatarProps> = ({className}) => {
    const {userProfile, accountClaims, currentUserEmail} = useAuthContext();

    const name = userProfile?.name || accountClaims?.name || '';
    const email = currentUserEmail || userProfile?.username || '';
    const label =
        name && email && name !== email ? `${name} (${email})` : name || email;

    return (
        <Link
            to={NavigationRoutes.profile()}
            className={`user-avatar ${className ?? ''}`}
            title={label ? `${label} – Profile` : 'Profile'}
            aria-label="Your profile"
        >
            {getInitials(name, email)}
        </Link>
    );
};

export default UserAvatar;
